import { render, staticRenderFns } from "./SelfVerify.vue?vue&type=template&id=b18feff0&scoped=true"
import script from "./SelfVerify.vue?vue&type=script&lang=js"
export * from "./SelfVerify.vue?vue&type=script&lang=js"
import style0 from "./SelfVerify.vue?vue&type=style&index=0&id=b18feff0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18feff0",
  null
  
)

export default component.exports